import dayjs from "dayjs";

export const getTimeStamp = (DATE_FORMAT: string = "") => {
  return dayjs().format(DATE_FORMAT);
}